import { clearAllUserData } from '@/config/api';

export interface ApiError {
  message: string;
  status?: number;
  code?: string;
}

export const handleApiError = (error: any): ApiError => {
  console.log('🔍 Handling API error:', error);
  
  // Handle network errors
  if (error.code === 'NETWORK_ERROR' || error.code === 'ECONNABORTED') {
    return {
      message: 'Error de conexión. Verifica tu conexión a internet.',
      code: error.code
    };
  }
  
  // Handle axios errors with response
  if (error.response) {
    const status = error.response.status;
    const data = error.response.data;
    
    console.log('🔍 Error response status:', status);
    console.log('🔍 Error response data:', data);
    
    // Handle authentication errors
    if (status === 401 || status === 403) {
      console.log('🚨 Authentication error - clearing user data');
      clearAllUserData();
      
      return {
        message: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
        status: status
      };
    }
    
    // Handle server errors
    if (status >= 500) {
      return {
        message: 'Error del servidor. Intenta nuevamente más tarde.',
        status: status
      };
    }
    
    // Handle client errors
    if (status >= 400) {
      const errorMessage = data?.error?.message || data?.message || 'Error en la solicitud';
      return {
        message: errorMessage,
        status: status
      };
    }
  }
  
  // Handle request errors (no response received)
  if (error.request) {
    console.log('🔍 No response received:', error.request);
    return {
      message: 'No se pudo conectar con el servidor. Verifica tu conexión.',
      code: 'NO_RESPONSE'
    };
  }
  
  // Handle other errors
  return {
    message: error.message || 'Error inesperado',
    code: 'UNKNOWN_ERROR'
  };
};

export const logError = (error: any, context?: string) => {
  const timestamp = new Date().toISOString();
  console.group(`🚨 Error Log - ${timestamp}`);
  
  if (context) {
    console.log('📍 Context:', context);
  }
  
  console.log('❌ Error:', error);
  console.log('📊 Error type:', typeof error);
  console.log('📋 Error keys:', Object.keys(error));
  
  if (error.response) {
    console.log('📡 Response status:', error.response.status);
    console.log('📡 Response data:', error.response.data);
    console.log('📡 Response headers:', error.response.headers);
  }
  
  if (error.request) {
    console.log('📤 Request:', error.request);
  }
  
  console.log('📝 Stack trace:', error.stack);
  console.groupEnd();
};

// Helper function to check if error is a backend error
export const isBackendError = (error: any): boolean => {
  return (
    error.response?.status >= 500 ||
    error.code === 'NETWORK_ERROR' ||
    error.code === 'ECONNABORTED' ||
    error.message?.includes('timeout') ||
    error.message?.includes('fetch') ||
    !error.response
  );
};
